import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const ShareIcon = createIcon({
  displayName: 'ShareIcon',
  path: [
    <path
      d='M6.75 8.75C5.64543 8.75 4.75 9.64543 4.75 10.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25H17.25C18.3546 19.25 19.25 18.3546 19.25 17.25C19.25 17.25 19.25 12.7501 19.25 10.75C19.25 8.74994 17.25 8.75 17.25 8.75'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />,
    <path
      d='M15.364 5.18188L12.182 1.9999L9 5.18188'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />,
    <path
      d='M12.1265 3.49848V13.7515'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  ],
  defaultProps: defaultProps
})
